
import { Column } from "primereact/column";
import { InputSwitch } from "primereact/inputswitch";
import React, { forwardRef, useImperativeHandle } from "react";
import systemFeaturesAPI from "../../../../services/system_features";
import { DataTable } from "primereact/datatable";

const SystemFeaturesListComponent = forwardRef((props, ref) => {

  const schoolId = "";
  const trainingId = "";
  const accessToken = "";
  //
  //const createModalRef = useRef();
  //const updateModalRef = useRef();
  //
  //
  const queryList = systemFeaturesAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    1,
    1000000,
  );
  const features = queryList?.data?.data;
  const orderedFeatures = features?.slice().sort((a, b) => {
    if (a.category < b.category) return -1;
    if (a.category > b.category) return 1;
    return 0;
  });
  //
  const updateFeature = (id, value) => {
    systemFeaturesAPI
      .UpdateOne(accessToken, id, { activated: value })
      .then((data) => {
        queryList?.refetch();
      });
  };
  //
  useImperativeHandle(ref, () => ({
    refresh: () => {
      queryList?.refetch();
    },
  }));
  //
  return (
    <>
      <DataTable value={orderedFeatures} rowGroupMode="subheader" groupRowsBy="category" selectionMode="single" scrollable scrollHeight="600px" rowGroupHeaderTemplate={(data) => {
        return (
          <div className="flex align-items-center gap-2">
            <span className="font-bold">{data.category}</span>
          </div>
        );
      }} size="small">
        <Column field="name" header="Fonctionalité"></Column>
        <Column field="presentation" header="Présentation"></Column>
        <Column
          field="activated"
          header="Active?"
          body={(item) => (
            <InputSwitch
              inputId="chkStatus"
              className="mr-2"
              checked={item?.activated}
              tooltipOptions={{ position: "top" }}
              onChange={(e) => {
                updateFeature(item.id, e.value);
              }}
            />
          )}
        ></Column>
      </DataTable>

    </>
  );
});

export default SystemFeaturesListComponent;
